import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormikHelpers } from 'formik'
import { AddressFormFields } from '../forms/types'
import { updateAddress } from '../api'
import { overrideAddress } from '../db/addresses'
import { extractErrorMessage } from '../../../shared/utils/apiUtils'
import { Address } from '../types'
import { AddressForm } from '../forms/AddressForm'
import { AppContext } from '../../../app/AppContext'

const AddressEditSection: React.FC<{ data: Address }> = ({ data }) => {
  const navigate = useNavigate()
  const { addAlertErrorMessage } = useContext(AppContext)

  const initialValues: AddressFormFields = {
    name: data.name,
    address: {
      street: data.address.street != null ? data.address.street : '',
      city: data.address.city != null ? data.address.city : '',
      cap: data.address.cap != null ? data.address.cap : '',
      country: data.address.country != null ? data.address.country : '',
      latitude: data.address.latitude,
      longitude: data.address.longitude,
    },
    phoneNumbers: data.phoneNumbers,
    emailAddresses: data.emailAddresses,
    files: data.files,
  }

  const onSubmit = async (
    values: AddressFormFields,
    { resetForm }: FormikHelpers<AddressFormFields>
  ): Promise<void> => {
    const address = { ...data }
    address.name = values.name
    address.address = values.address
    address.phoneNumbers = values.phoneNumbers
    address.emailAddresses = values.emailAddresses
    address.files = values.files

    try {
      const updatedAddress = await updateAddress(address)
      await overrideAddress(updatedAddress)

      resetForm({ values })

      navigate(-1)
    } catch (error: any) {
      addAlertErrorMessage(extractErrorMessage(error))
    }
  }

  return <AddressForm initialValues={initialValues} onSubmit={onSubmit} />
}

export { AddressEditSection }
